import type { OnboardingOfferKey } from "@/services/api-hooks/offers";

import { track } from "../track";
import {
  buildOfferAnalyticsBaseParams,
  OFFER_PAY_PROVIDER,
} from "./offerAnalyticsParams";

interface Params {
  offerKey: OnboardingOfferKey;
  productId: string;
}

export const trackOfferSaleCheckout = ({ offerKey, productId }: Params) =>
  track({
    event: "sale_checkout",
    ...buildOfferAnalyticsBaseParams(offerKey),
    pay_provider: OFFER_PAY_PROVIDER,
    subs_id: productId,
    product_id: productId,
  });
